import { ContactUsType, LoyaltyChallengeConfig } from '@shared/models';

import {
  DeviceType,
  DISPLAY_CONDITION,
  ProductCheckTabType,
  RewardFormat,
  SubType,
  TitleType,
  Variants,
} from '../utils';

export const LACERTA_CONFIG: LoyaltyChallengeConfig = {
  currency: 'GBP',
  appIcon: 'assets/images/lacerta/favicon.ico',
  cssVariables: {
    'font-family-regular': 'ASDAText-Regular',
    'font-family-bold': 'ASDAText-Bold',
    'font-family-subline': 'ASDADisplay-Subline',
    'font-family-headline': 'ASDADisplay-Headline',

    'navbar-height': '65px',
    'navbar-background-color': '#ffffff',

    'nav-link-color': '#737373',
    'nav-link-active-color': '#002935',

    'nav-item-bg-color': 'white',
    'nav-item-active-bg-color': 'white',
    'nav-item-font-family': 'var(--font-family-bold)',
    'nav-item-hover-bg-color': 'rgb(0 0 0 / 10%)',

    'body-color': '#000000',
    'body-background-color': '#ffffff',

    'challenge-primary-color': '#6DBA44',
    'tooltip-text-color': 'white',
    'tooltip-background-color': 'black',
  },
  rewardFormat: RewardFormat.PRICE,
  og: {
    title: 'ASDA Rewards Missions | Earn up to £50 in your Cashpot',
    description:
      'Earn up to £50 in your ASDA Rewards Cashpot with monthly Missions. Activate personalised missions, shop your favourite brands, and unlock savings.',
  },
  rewardTemplate: '{points}',
  pages: {
    availablePages: ['help', 'current', 'history'],
    help: {
      meta: {
        title: 'ASDA Rewards Missions — Help & FAQs',
        keywords:
          'ASDA Rewards, Missions, Cashpot, how to earn rewards, loyalty rewards help, mission FAQs',
        description:
          'Find help with ASDA Rewards Missions — learn how to activate missions, earn Cashpot rewards, and redeem up to £50 each month.',
      },
      header: {
        background: '#002935',
        goBackButton: {
          text: 'Go Back To My Challenges',
          backgroundColor: '#002935',
          color: 'white',
          fontFamily: 'var(--font-family-subline)',
          borderRadius: '5px',
        },
        bannerAlternativeText: 'ASDA Rewards missions help banner',
        bannerUrl: {
          mobile: 'assets/images/lacerta/cover-help-mobile.webp',
          tablet: 'assets/images/lacerta/cover-help-mobile.webp',
          desktop: 'assets/images/lacerta/cover-help-desktop.webp',
        },
        howToPlay: {
          specificDisplayCondition: DISPLAY_CONDITION.ALWAYS,
        },
      },
      faqVariant: {
        variant: Variants.VARIANT_1,
        title: {
          displayWhenCampaignBis: false,
          label: 'Questions',
          type: TitleType.TEXT,
          styles: {
            color: '#002935',
            fontSize: '26px',
            fontFamily: 'var(--font-family-headline)',
          },
        },
        questions: [
          {
            title: 'What is Your Missions?',
            content:
              'Your Missions is a new way to earn rewards. You can earn up to £50 a month buying your favourite products. Every month you will receive 20 personalised missions. Select up to 10 missions per month to start accumulating your Cashpot. Your earnings will be added to your Cashpot after the mission resets.',
          },
          {
            title: 'Do I have to select 10 missions?',
            content:
              'No, but you can select up to 10 missions at a time. The more you select, the more rewards you can earn.',
          },
          {
            title: 'Can I change my missions?',
            content:
              'Yes. As long as you haven’t completed any in store purchases or online orders through the mission, you can cancel it and select a different one instead. Once you’ve made a purchase, the mission will remain in your queue until it is completed or has expired.',
          },
          {
            title:
              'Will I earn additional rewards if my purchases exceed my mission’s purchase goal?',
            content: 'No, additional purchases will not increase your reward.',
          },
          {
            title:
              'Can I combine purchases from different stores to count toward meeting a specific mission’s purchase goal?',
            content:
              'Yes. All your purchases count as long as you scan your Rewards card at in store checkout or make an online purchase under your linked account.',
          },
          {
            title: 'How are my missions determined?',
            content:
              'We do our best to present you with Missions for brands and items that are most relevant to you and your household.',
          },
          {
            title:
              'How long will it take for my purchases to show up on my missions page?',
            content:
              'Your personal page is updated within 48-hours after each in store purchase, or the day of pickup or delivery of each online order.',
          },
          {
            title: 'How can I follow the progress of my missions?',
            content:
              'Check your personal page to track all your developments — you can view your purchases, rewards, and progress. Remember to save your personalised page in your favourites for easy access any time!',
          },
          {
            title:
              'Can I combine my missions with other promotions or discounts?',
            content: 'Yes! Missions can be combined with most promotions.',
          },
          {
            title: 'Do my missions expire?',
            content:
              'The expiration periods vary and will be noted on the missions.',
          },
          {
            title: 'What is a Qualifying Purchase?',
            content:
              'Please see the Terms & Conditions for more information about Qualifying Purchases and Exclusions.',
          },
          {
            title:
              'What should I do if I made a purchase, but I do not see it reflected on the progress of my mission?',
            content:
              'Most missions will include a list of qualifying products. You can view the list by selecting the information icon on the mission. For further assistance, please call Customer Services on 0330 053 0222 Monday – Friday, 8:00am - 8:00pm GMT.',
          },
          {
            title: 'What happens when I complete a mission?',
            content:
              'Congratulations! Once you successfully complete a mission, the rewards will be added to your Cashpot within 5 days following the mission period end date.',
          },
          {
            title:
              'What happens if I place an order before the mission starts, will I be eligible?',
            content:
              'Only orders placed or amended, and delivered during the mission period will be eligible for rewards.',
          },
        ],
        accordion: {
          styles: {
            title: {
              color: '#002935',
              fontSize: '14px',
              fontFamily: 'var(--font-family-regular)',
            },
            description: {
              color: '#333333',
              fontSize: '12px',
              margin: '0 1rem',
              fontFamily: 'var(--font-family-light)',
              paddingBottom: '0 !important',
            },
          },
          iconMore: 'assets/images/lacerta/expand-more.svg',
          iconLess: 'assets/images/lacerta/expand-less.svg',
          alternativeTextExpandMore: 'Expand More',
          alternativeTextExpandLess: 'Expand Less',
        },
      },
      templateBeforeContactForm: [
        '<div style="padding-top: 2rem;margin: 0 auto; width: 80%;color: #002935;margin-bottom: 1rem;">',
        '<h1 style="font-size: 24px; font-family: var(--font-family-headline); text-align:center">Short T&C’s</h1>',
        '<p style="font-size: 14px;font-family: var(--font-family-regular);">1.Includes: Eligible items listed on the in-app mission purchased in store or online at Asda.com Excludes: Items not included within in-app eligible item list</p>',
        '<p style="font-size: 14px;font-family: var(--font-family-regular);">2. Mission starts {variable} and must be completed on or before {variable} 23:59. Valid in store and online at Asda.com. Asda Rewards Terms & Conditions apply. Subject to availability. Selected stores may apply. Value added to the Rewards Cashpot at the end of each month, upon completion of the mission in set time frame.</p>',
        '<h1 style="padding-top: 2rem; font-size: 24px; font-family: var(--font-family-headline); text-align:center;margin-bottom: 1rem;">Long T&C’s</h1>',
        '<p style="font-size: 14px;font-family: var(--font-family-regular);">1. Includes: [Eligible items listed on the in-app mission] purchased in store or online at Asda.com</p>',
        '<p style="font-size: 14px;font-family: var(--font-family-regular);">2. Excludes: Items not included within in-app eligible item list, including George.com, petrol, all items from a petrol station, any purchases from Asda Express stores, postage stamps, tobacco and tobacco related products, gift vouchers and gift cards, all National Lottery purchases, phone top up cards/ vouchers, pharmacy, NHS prescriptions, infant formula and any third party concessions or products.</p>',
        '<p style="font-size: 14px;font-family: var(--font-family-regular);">3. Each mission will include the details for how to complete the activity including required spend, earn available and eligible products. The mission must be completed in the outlined time period. This can be achieved across multiple shops, and the Cashpot will be awarded up to 5 days after the mission has ended. Cashpot awarded after the application of any discounts, including Cashpot vouchers, coupons, colleague discounts, reduced to clear prices or promotional offers including link save purchases. For a shop to qualify it must be ordered or amended and delivered or collected between {variable} 00:00 and {variable} 23:59. Asda Rewards Terms & Conditions apply. Subject to availability. Selected stores may apply. Collection and delivery charges apply. The latest version of the app must be downloaded to access Your Missions.</p>',
      ],
      contactUs: {
        type: ContactUsType.TEMPLATE,
        config: [
          '<div style="margin: 2rem 0;color: #002935;">',
          '<p style="font-family: var(--font-family-headline); font-size: 24px;margin-bottom: 15px;">Contact us</p>',
          '<p style="font-family: var(--font-family-regular); margin-bottom: 0px;font-size: 15px;">Contact our help centre at <span style="font-family: var(--font-family-bold);color: #002935;">0330 053 0222</span></p>',
          '</div>',
        ],
      },
      displayContactUsUnlogged: true,
    },
    currentChallenges: {
      meta: {
        title: 'Current ASDA Rewards Missions | Activate & Earn £50',
        keywords:
          'ASDA Rewards, Missions, Cashpot, current missions, monthly missions, loyalty rewards, earn £50',
        description:
          'Earn up to £50 in your ASDA Rewards Cashpot with monthly Missions. Activate personalised missions, shop your favourite brands, and unlock savings.',
      },
      background: 'white',
      howDoesitWork: {
        color: 'white',
        fontFamily: 'var(--font-family-bold)',
        backgroundColor: '#002E3B',
        containerBackgroundColor: 'white',
        text: 'How it works',
        borderRadius: '6px',
        containerPadding: '0',
        modal: {
          background: '#FFFFFF',
          title: {
            text: 'How it works',
            color: '#002E3B',
            fontFamily: 'var(--font-family-bold)',
          },
          closeButton: {
            imageUrl: 'assets/images/default/close-button.svg',
            alternativeText: 'Close the tutorial',
            color: '#002E3B',
          },
          skipNowButton: {
            text: 'Skip for now',
            color: 'white',
            fontFamily: 'var(--font-family-bold)',
            backgroundColor: '#002E3B',
            borderRadius: '6px',
          },
        },
      },
      howToPlay: {
        specificDisplayCondition: DISPLAY_CONDITION.DEFAULT,
        title: {
          color: 'white',
          fontFamily: 'var(--font-family-headline)',
          text: 'HOW IT WORKS',
        },
      },
      templateBeforeChallenges: {
        mobile: [
          '<div style="text-align: center; border-radius: 10px; padding: 10px; background-color: #002E3B; color: white; margin: 0 6vw 30px">',
          "<div style='font-size: 13px;font-family: var(--font-family-subline);'>Your Missions campaign is now over. Thank you for taking part and congratulations to the winners! Your rewards will be available very soon.<br/>We have paused Your Missions for November but we look forward to seeing you very soon!</div>",
          '</div>',
        ],
        tablet: [
          '<div style="text-align: center;  border-radius: 10px; padding: 10px; background-color: #002E3B; color: white; margin-bottom: 30px">',
          "<div style='font-size: 13px;font-family: var(--font-family-subline);'>Your Missions campaign is now over. Thank you for taking part and congratulations to the winners! Your rewards will be available very soon.<br/>We have paused Your Missions for November but we look forward to seeing you very soon!</div>",
          '</div>',
        ],
        desktop: [
          '<div style="text-align: center; border-radius: 10px; padding: 10px; background-color: #002E3B; color: white; margin: 0 auto 50px; max-width: 900px">',
          "<div style='font-size: 15px;font-family: var(--font-family-subline);'>Your Missions campaign is now over. Thank you for taking part and congratulations to the winners! Your rewards will be available very soon.<br/>We have paused Your Missions for November but we look forward to seeing you very soon!</div>",
          '</div>',
        ],
      },
    },
    pastChallenges: {
      meta: {
        title: 'My ASDA Rewards Missions History',
        keywords:
          'ASDA Rewards, Missions, Cashpot, missions history, past missions, completed missions, earned rewards',
        description:
          'Browse past ASDA Rewards Missions and earn up to £50 in your Cashpot when you shop your favourite brands.',
      },
      banner: {
        visibility: true,
        title: 'History',
        bannerAriaLabel: 'History page displaying past challenges',
        background: {
          mobile:
            "url('assets/images/lacerta/mobile-history-cover.webp') center / cover no-repeat",
          tablet:
            "url('assets/images/lacerta/mobile-history-cover.webp') center / cover no-repeat",
          desktop:
            "url('assets/images/lacerta/desktop-history-cover.webp') center / cover no-repeat",
        },
        styles: {
          title: {
            margin: 'unset',
            color: '#6DBA44',
            fontSize: '32px',
            fontFamily: 'var(--font-family-headline)',
            textAlign: 'center',
          },
          banner: {
            height: '160px',
            display: 'flex',
            alignItems: 'center',
            marginBottom: '2rem',
            justifyContent: 'center',
          },
        },
      },
      accordion: {
        variant: Variants.VARIANT_1,
        alternativeTextExpandMore: 'Show more',
        alternativeTextExpandLess: 'Show less',
        icon: {
          imageUrl: 'assets/images/lacerta/history-page-icon.svg',
          alternativeText: 'Icon',
        },
        date: {
          color: '#002935',
          format: 'd MMMM yyyy',
          fontFamily: 'var(--font-family-bold)',
          template: '{firstDate} - {lastDate}',
        },
        reward: {
          color: '#002935',
          fontFamily: 'var(--font-family-subline)',
        },
      },
      noChallengesText: {
        color: '#002935',
        fontFamily: 'var(--font-family-bold)',
        text: 'No selected challenges',
      },
      noRewardsText: {
        color: '#002935',
        fontFamily: 'var(--font-family-bold)',
        text: 'No rewards earned',
      },
    },
    sorry: {
      background: '#012A36',
      content: [
        '<div style="font-size: 1.5rem; text-align: center; color: white; font-family: var(--font-family-bold);">Oops!</div>',
        '<div style="font-size: 1.2rem; text-align: center; color: white; font-family: var(--font-family-bold);">This site is temporarily unavailable.</div>',
      ],
    },
  },
  components: {
    header: {
      variant: Variants.VARIANT_12,
      backgroundColor: '#002935',
      bannerAriaLabel: 'ASDA Rewards missions banner, win up to £50',
      backgroundImage: {
        mobile: {
          imageUrl: 'assets/images/lacerta/mobile-cover.webp',
        },
        tablet: {
          imageUrl: 'assets/images/lacerta/mobile-cover.webp',
        },
        desktop: {
          imageUrl: 'assets/images/lacerta/desktop-cover.webp',
        },
      },
      campaignDate: {
        color: 'white',
        fontFamily: 'var(--font-family-subline)',
        template: 'From {startDate} - {endDate}',
      },
      logo: {
        imageUrl: 'assets/images/lacerta/asda-rewards.svg',
        alternativeText: 'ASDA Rewards Your Missions',
      },
      earnUpTo: {
        color: 'white',
        fontFamily: 'var(--font-family-bold)',
        textTemplate: {
          desktop:
            'Earn up to <span style="font-size: 4vw; color: #6dba44;font-family: var(--font-family-subline);">£50</span> per month <br/><span style="font-family: var(--font-family-regular);">buying your favourite products!</span>',
          mobile:
            'Earn up to <span style="font-size: 10vw; color: #6dba44;font-family: var(--font-family-subline);">£50</span> per month <br/><span style="font-family: var(--font-family-regular);">buying your favourite products!</span>',
          tablet:
            'Earn up to <span style="font-size: 8vw"; color: #6dba44;font-family: var(--font-family-subline);>£50</span> per month <br/><span style="font-family: var(--font-family-regular);">buying your favourite products!</span>',
        },
      },
    },
    brands: {
      variant: Variants.VARIANT_1,
      brandsBgColor: 'white',
      border: 'none',
      alternativeText: '',
    },
    footer: {
      variant: Variants.VARIANT_1,
      mobileVisiblity: true,
      styles: {
        display: 'flex',
        padding: '30px 0',
        alignItems: 'center',
        flexDirection: 'row',
        justifyContent: 'space-evenly',
        backgroundColor: '#002E3B',
      },
      linkStyles: {
        color: '#FFFFFF',
        fontSize: '16px',
        textDecoration: 'none',
        fontFamily: 'var(--font-family-bold)',
      },
      links: [
        {
          url: 'help',
          label: 'How it works',
        },
        {
          url: 'help',
          fragment: 'terms',
          label: 'Terms & conditions',
        },
      ],
    },
    tutorial: {
      background: '#002935',
      carousel: {
        config: {
          sectionAriaLabel: 'Tutorial carousel',
          controlsAriaLabel: 'Carousel controls',
          paginationAriaLabel: 'Slide indicators',
          dots: {
            activeBg: 'white',
            inactiveBg: '#00442A',
            ariaLabel: 'Go to slide {variable} of {variable}',
          },
          slideIndicatorLabel: 'Slide {variable} on {variable}',
          controls: {
            leftIcon: {
              imageUrl: 'assets/images/lacerta/chevron-left.svg',
              alternativeText: 'Go to the previous slide',
            },
            rightIcon: {
              imageUrl: 'assets/images/lacerta/chevron-right.svg',
              alternativeText: 'Go to the next slide',
            },
          },
        },
        items: {
          variant: Variants.VARIANT_1,
          styles: {
            title: {
              color: '#272F35',
              fontFamily: 'var(--font-family-subline)',
            },
            description: {
              color: '#012A35',
              fontFamily: 'var(--font-family-regular)',
            },
            card: {
              border: 'none',
              background: 'white',
              borderRadius: '16px',
              boxShadow: 'none',
            },
          },
          steps: [
            {
              title: 'Start',
              description: 'Choose up to 10 missions to complete',
              indicatorImage: {
                alternativeText: 'Step 1',
                imageUrl: 'assets/images/lacerta/step1.svg',
              },
              picture: {
                imageUrl: 'assets/images/lacerta/step-1.webp',
                alternativeText: 'Choose up to 10 missions to complete',
              },
            },
            {
              title: 'Buy',
              description:
                'Shop your favourite products to start accumulating money',
              indicatorImage: {
                alternativeText: 'Step 2',
                imageUrl: 'assets/images/lacerta/step2.svg',
              },
              picture: {
                imageUrl: 'assets/images/lacerta/step-2.webp',
                alternativeText:
                  'Shop your favourite products to start accumulating money',
              },
            },
            {
              title: 'Earn',
              description:
                'All money earned will be added to your Cashpot after the Missions reset at the end of the month',
              indicatorImage: {
                alternativeText: 'Step 3',
                imageUrl: 'assets/images/lacerta/step3.svg',
              },
              picture: {
                imageUrl: 'assets/images/lacerta/step-3.webp',
                alternativeText:
                  'Cashpot rewards are added after monthly missions reset',
              },
            },
          ],
        },
      },
    },
    wallet: {
      variant: Variants.VARIANT_1,
      label: {
        color: '#002935',
        text: 'Missions Cashpot earned',
        fontFamily: 'var(--font-family-regular)',
      },
      amount: {
        color: '#002935',
        fontFamily: 'var(--font-family-subline)',
      },
      isOnlyReward: true,
    },
    navbar: {
      variant: Variants.VARIANT_3,
      menuVariant: Variants.VARIANT_2,
      hasLayoutPaddingTop: true,
      dropdownLabel: 'Menu',
      fontFamily: 'var(--font-family-bold)',
      openButton: {
        imageUrl: 'assets/images/lacerta/menu-icon.svg',
        buttonTitle: 'Click to see more options',
        imageAlt: 'Click to see more options',
      },
      logo: {
        url: 'current',
        imageUrl: 'assets/images/lacerta/retailer-logo.webp',
        alternativeText: 'ASDA logo',
        height: '50px',
        showOnMobile: false,
      },
      navbarAriaLabel: 'ASDA Rewards main navigation',
      items: [
        {
          url: 'current',
          label: 'My Missions',
          ariaLabel: 'Go to My Missions page',
        },
        {
          url: 'history',
          label: 'History',
          ariaLabel: 'Go to History page',
        },
        {
          url: 'help',
          label: 'Help?',
          ariaLabel: 'Go to Help page',
        },
      ],
    },
    countdown: {
      variant: Variants.VARIANT_1,
      showOnPages: 'all',
      showAfterCampaignSummaryWhen: [],
      showBeforeCampaignSummaryWhen: [],
      showOnNavbarWhen: [DeviceType.DESKTOP],
      titleAppearing: ['column', 'row', 'row'],
      titleVerticalAlignment: ['center', 'center', 'center'],
      labelStyle: {
        color: '#002935',
        fontFamily: 'var(--font-family-regular)',
      },
      title: {
        color: '#002935',
        showTitleOnMobile: true,
        fontFamily: 'var(--font-family-bold)',
        label: 'Missions end in',
      },
      numberStyle: {
        color: '#002935',
        backgroundColor: '#6DBA44',
        fontFamily: 'var(--font-family-subline)',
      },
      texts: {
        days: 'DAYS',
        hours: 'HOURS',
        minutes: 'MINUTES',
        seconds: 'SECONDS',
      },
    },
    challenges: {
      elements: {
        winCard: {
          variant: Variants.VARIANT_7,
          backgroundColor: 'white',
          completedMsg: {
            backgroundImage: '/assets/images/lacerta/completed-badge.svg',
            color: '#002E3B',
            fontFamily: 'var(--font-family-bold)',
            text: 'Completed',
          },
          rewardAmount: {
            fontFamily: 'var(--font-family-bold)',
            color: '#002E3B',
            backgroundColor: '#F9E547',
            iconPosition: 'before',
            picture: {
              imageUrl: 'assets/images/lacerta/star-icon.svg',
              alternativeText: 'Reward icon',
              width: '25px',
            },
          },
          eVoucherMsg: {
            fontFamily: 'var(--font-family-regular)',
            color: '#002E3B',
            text: 'Your Cashpot will be issued to you after \n Your Missions ends',
          },
        },
        selectionButton: {
          variant: Variants.VARIANT_7,
          backgroundColor: '#F9E547',
          minimumSpendLabel: {
            color: '#002E3B',
            fontFamily: 'var(--font-family-regular)',
            text: 'Maximum one visit per day, minimum spend £{variable}',
          },
          picture: {
            imageUrl: 'assets/images/lacerta/star-icon.svg',
            alternativeText: 'Reward icon',
          },
          rewardContainer: {
            fontFamily: 'var(--font-family-bold)',
            color: '#002E3B',
            text: 'Earn up to',
            stepText: 'Spend {variable} to earn',
          },
          button: {
            backgroundColor: '#002E3B',
            fontFamily: 'var(--font-family-bold)',
            color: 'white',
            text: 'Activate',
            title: 'Activate this challenge',
          },
        },
        unselectionButton: {
          variant: Variants.VARIANT_2,
          text: 'Deactivate',
          title: 'Deactivate this mission',
          color: '#FF0000',
          fontFamily: 'var(--font-family-subline)',
        },
        outOfStock: {
          variant: Variants.VARIANT_1,
          backgroundColor: 'rgba(0, 46, 59, 0.85)',
          borderRadius: '16px',
          description: {
            text: 'This mission <br/> was popular, <br/>sorry you missed out',
            textColor: 'white',
            fontFamily: 'var(--font-family-bold)',
            fontSize: '18px',
          },
        },
      },
      step: {
        [SubType.DEFAULT]: {
          variant: Variants.VARIANT_6,
          bannerAlternativeText: 'ASDA Rewards mission banner',
          logoAlternativeText: 'Logo banner',
          header: {
            height: '143px',
            backgroundColor: '#FFFFFF',
          },
          subHeader: {
            color: '#002E3B',
            backgroundColor: 'white',
            completedBackgroundColor: 'white',
            fontFamily: 'var(--font-family-bold)',
            fontSize: '12px',
          },
          body: {
            progressbar: {
              pictureStageReached: {
                imageUrl: 'assets/images/lacerta/reward-reached.svg',
                alternativeText: 'Reached reward',
                width: '55px',
              },
              earnLabel: 'Earn',
              spendLabel: 'Spend',
              labelColor: '#002E3B',
              progressColor: '#6DBA44',
              containerColor: '#F2F2F2',
              labelFontFamily: 'var(--font-family-bold)',
            },
            rewards: {
              rewardFontFamily: 'var(--font-family-bold)',
              showReachedIconInBubble: true,
              backgroundColors: {
                bubbleWidth: '65px',
                bubbleHeight: '54px',
                backgroundImage: 'assets/images/lacerta/max-reward.svg',
                default: {
                  fill: '#F9E547',
                  stroke: '#F9E547',
                  rewardColor: '#002E3B',
                },
                reached: {
                  fill: '#F9E547',
                  stroke: '#F9E547',
                  rewardColor: '#002E3B',
                },
                unreached: {
                  fill: '#FFFFFF',
                  stroke: '#C9D2D8',
                  rewardColor: '#002E3B66',
                },
                alternativeText: {
                  reached: 'I earned £{variable}',
                  default: 'I earned £{variable}',
                  unreached: 'Earn £{variable}',
                },
              },
            },
            targets: {
              color: '#002E3B',
              fontFamily: 'var(--font-family-bold)',
            },
          },
          footer: {
            backgroundColor: 'white',
            unselectLabel: {
              color: '#FF0000',
              fontFamily: 'var(--font-family-subline)',
              label: 'Deactivate',
            },
            totalSpent: {
              color: '#002E3B',
              fontFamily: 'var(--font-family-regular)',
              label: 'Progress',
              spentAmountFontFamily: 'var(--font-family-bold)',
            },
            eligibleProductLabel: {
              color: '#000000',
              fontFamily: 'var(--font-family-bold)',
              label: 'Eligible products',
            },
          },
        },
      },
      frequency: {
        [SubType.DEFAULT]: {
          variant: Variants.VARIANT_11,
          header: {
            backgroundImage: {
              url: 'assets/images/lacerta/frequency-banner.svg',
              bannerAriaLabel: 'ASDA Rewards visits mission banner',
            },
            height: '143px',
          },
          subHeader: {
            backgroundColor: 'white',
            completedBackgroundColor: 'white',
            title: {
              color: '#002E3B',
              fontFamily: 'var(--font-family-bold)',
              label: 'Shop in-store {variable} times',
            },
          },
          body: {
            minimumSpendLabel: {
              color: '#002E3B',
              fontFamily: 'var(--font-family-regular)',
              text: 'Maximum one visit per day, minimum spend £{variable}',
            },
            rewardRatio: {
              color: '#002E3B',
              fontFamily: 'var(--font-family-bold)',
              backgroundColor: '#F9E547',
              text: 'Earn £',
              picture: {
                imageUrl: 'assets/images/lacerta/star-icon.svg',
                alternativeText: '',
              },
            },
            stamps: {
              showNumbers: true,
              iconSelected: 'assets/images/lacerta/frequency-stamp-success.svg',
              iconNonSelected:
                'assets/images/lacerta/frequency-stamp-empty.svg',
              nonActiveNumberColor: 'rgba(0, 46, 59, 0.4)',
              activeNumberColor: '#002E3B',
            },
            progressBar: {
              activeColor: '#6DBA44',
              defaultColor: '#D2D9DC',
            },
            visitsContainer: {
              defaultBorderColor: '#D2D9DC',
              activeBorderColor: '#6DBA44',
            },
            footer: {
              backgroundColor: 'white',
              unselectLabel: {
                color: '#FF0000',
                fontFamily: 'var(--font-family-subline)',
                text: 'Deactivate',
              },
            },
          },
        },
      },
    },
    challengeSummary: {
      variant: Variants.VARIANT_1,
      stackOnMobile: false,
      title: {
        color: '#002935',
        text: 'Your Missions',
        fontFamily: 'var(--font-family-bold)',
        transform: 'none',
      },
      challengeSelection: {
        text: 'Select up to 10 Missions to complete.\n Any Cashpot earned will be added when your Missions ends.',
        defaultFontSize: '14px',
        color: '#002E3B',
        fontFamily: 'var(--font-family-regular)',
      },
      challengeLabels: {
        onGoingLabel: {
          color: '#002E3B',
          text: 'Ongoing',
          fontFamily: 'var(--font-family-regular)',
        },
        completedLabel: {
          color: '#002E3B',
          text: 'Completed',
          fontFamily: 'var(--font-family-regular)',
        },
      },
      counterBorderRadius: '5px',
      challengesInfos: {
        color: '#002E3B',
        backgroundColor: '#C3CDD1',
        fontFamily: 'var(--font-family-bold)',
      },
      onGoingChallengesInfo: {
        color: '#002E3B',
        backgroundColor: '#6DBA44',
        fontFamily: 'var(--font-family-bold)',
      },
    },
    modals: {
      closeButton: {
        label: 'Close',
        textColor: 'white',
        borderRadius: '6px',
        backgroundColor: '#002935',
        fontFamily: 'var(--font-family-bold)',
        ariaLabel: 'Close this dialog',
      },
      unselectChallenge: {
        backgroundColor: '#FFFFFF',
        header: {
          backgroundColor: '',
          backgroundImage: '',
        },
        frequencyHeaderImages: {
          [SubType.DEFAULT]: {
            imageUrl: 'assets/images/lacerta/frequency-header-banner.webp',
            alternativeText: 'Frequency challenge',
          },
        },
        title: {
          color: '#272f35',
          fontFamily: 'var(--font-family-bold)',
          label: 'Are you sure you want to unselect this mission?',
        },
        body: {
          color: '#002935',
          fontFamily: 'var(--font-family-regular)',
          label: 'Don’t worry. If you regret it you can select it again!',
        },

        actionButtons: {
          variant: Variants.VARIANT_1,
          closeButton: {
            label: 'No',
            borderRadius: '4px',
            borderColor: '#002935',
            textColor: '#002935',
            backgroundColor: 'white',
            fontFamily: 'var(--font-family-bold)',
            ariaLabel: 'Cancel this button',
          },
          confirmButton: {
            label: 'Yes',
            borderRadius: '4px',
            textColor: '#FFFFFF',
            backgroundColor: '#002935',
            fontFamily: 'var(--font-family-bold)',
            ariaLabel: 'Are you sure you want to Unselect this mission?',
          },
        },
      },
      productCheck: {
        ariaLabel: '',
        backgroundColor: '#FFFFFF',
        fontFamily: 'var(--font-family-bold)',
        tabs: [
          {
            type: ProductCheckTabType.PRODUCT_LIST,
            label: 'Enter manually',
            searchable: true,
            inputPlaceholder: 'Enter a barcode to search',
            tableTitle: {
              text: 'List of eligible products',
              color: '#002E3B',
            },
            columns: {
              name: {
                header: 'Product',
                color: '#002E3B',
                fontFamily: 'var(--font-family-regular)',
              },
              code: {
                header: 'Barcode',
                color: '#002E3B',
                fontFamily: 'var(--font-family-regular)',
              },
            },
          },
        ],
      },
      firstSelection: {
        backgroundColor: 'white',
        title: {
          color: '#272F35',
          label: 'Yay! You started your first Mission',
          fontFamily: 'var(--font-family-subline)',
        },
        header: {
          backgroundImage: '',
          backgroundColor: 'white',
          logo: {
            imageUrl: 'assets/images/lacerta/first-selection.svg',
            alternativeText: 'You have selected the first challenge',
          },
        },
        body: {
          color: '#333333',
          fontFamily: 'var(--font-family-regular)',
          label: 'You can start {variable} more Missions.',
        },
      },
      lastSelection: {
        backgroundColor: 'white',
        title: {
          color: '#272F35',
          fontFamily: 'var(--font-family-bold)',
          label: 'You’ve hit the maximum number of Missions',
        },
        header: {
          backgroundImage: '',
          backgroundColor: 'white',
          logo: {
            imageUrl: 'assets/images/lacerta/last-selection.svg',
            alternativeText: 'You’ve hit maximum number of Missions',
          },
        },
        body: {
          color: '#272F35',
          fontFamily: 'var(--font-family-regular)',
          label:
            'No worries, if you want to select another Mission you can unselect one of the Missions you haven’t started yet.',
        },
      },
      maximumSelection: {
        backgroundColor: 'white',
        title: {
          color: '#272f35',
          fontFamily: 'var(--font-family-bold)',
          label: 'All Missions set!',
        },
        header: {
          backgroundImage: '',
          backgroundColor: 'white',
          logo: {
            imageUrl: 'assets/images/lacerta/maximum-selection.svg',
            alternativeText: 'You’ve hit maximum number of Missions',
          },
        },
        body: {
          color: '#272F35',
          fontFamily: 'var(--font-family-regular)',
          label: 'Shop your favourite brands and earn up £50!',
        },
      },
      outOfStockIssue: {
        backgroundColor: '#FFFFFF',
        title: {
          color: '#272f35',
          fontFamily: 'var(--font-family-bold)',
          label: 'Limit reached',
        },
        body: {
          color: '#272F35',
          fontFamily: 'var(--font-family-regular)',
          label:
            'This Mission has reached the maximum number of participants. Please choose another.',
        },
      },
      genericError: {
        backgroundColor: '#FFFFFF',
        title: {
          color: '#272f35',
          fontFamily: 'var(--font-family-bold)',
          label: 'Error',
        },
        body: {
          color: '#272F35',
          fontFamily: 'var(--font-family-regular)',
          label:
            "An error occurred, and the Mission couldn't be selected. Please check your connection and try again.",
        },
      },
      timeoutError: {
        backgroundColor: '#FFFFFF',
        title: {
          color: '#272f35',
          fontFamily: 'var(--font-family-bold)',
          label: 'Request timed out',
        },
        body: {
          color: '#272F35',
          fontFamily: 'var(--font-family-regular)',
          label:
            'Selecting the Mission took too long. Please check your connection and try again.',
        },
      },
      challengeUnavailable: {
        backgroundColor: '#FFFFFF',
        title: {
          color: '#272f35',
          fontFamily: 'var(--font-family-bold)',
          label: 'Campaign ended',
        },
        body: {
          color: '#272F35',
          fontFamily: 'var(--font-family-regular)',
          label:
            'This campaign has ended and Missions are no longer available for selection.',
        },
      },
    },
  },
};
